import { Injectable } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { CourtBookingSaveModalComponent } from '../containers/court-booking-save-modal/court-booking-save-modal.component';
import { CourtBookingSaveInputModel } from '../models/court-booking-save-input.model';

@Injectable({
  providedIn: 'root'
})
export class CourtBookingSaveLauncherService {
  constructor(private bsModalService: BsModalService) {}

  openCourtBookingSaveModal(courtBookingInput: CourtBookingSaveInputModel) {
      this.bsModalService.show(CourtBookingSaveModalComponent, {
          id: 1,
          class: 'fullscreen',
          initialState: { courtBookingInput }
      });
  }
}
